<template>
  <div class="lazy-component">
    <slot v-if="load" />
    <Loader v-else :use-background="false" :height="50" />
  </div>
</template>

<script>
import { useLazyStore } from '@/stores/lazyStore'
import { mapState } from 'pinia'
import { defineAsyncComponent } from 'vue'

const Loader = defineAsyncComponent(
  () => import('@/components/basic/atoms/LoadingOverlay.vue')
)

export default {
  components: { Loader },
  props: {
    delay: {
      type: Number,
      default: 500
    }
  },
  data() {
    return {
      visible: false
    }
  },
  computed: {
    ...mapState(useLazyStore, ['forceLoad']),
    load() {
      if (this.forceLoad) return true

      return this.visible
    }
  },
  methods: {
    listen() {
      const observer = new IntersectionObserver((entries) => {
        if (entries[0].intersectionRatio <= 0) return
        observer.disconnect()
        this.visible = true
      })
      setTimeout(() => {
        observer.observe(this.$el)
      }, this.delay)
    }
  },
  mounted() {
    if (!('IntersectionObserver' in window)) {
      this.visible = true
      return
    }
    this.listen()
  }
}
</script>
<style scoped>
.lazy-component {
  position: relative;
  min-height: 50px;
}
</style>
